import React from 'react';
import { Link, NavLink } from 'react-router-dom';
import { Flame } from 'lucide-react';
import ConnectWalletButton from './ConnectWalletButton';

const Header = () => {
  const linkCls = ({ isActive }) =>
    `text-sm font-display font-medium px-4 py-2 rounded-full transition-all ${
      isActive
        ? 'text-white bg-white/5 border border-white/10'
        : 'text-forge-muted hover:text-white'
    }`;
  return (
    <header className="sticky top-0 z-50 bg-[#07071A]/70 backdrop-blur-2xl border-b border-white/5">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        <Link to="/" data-testid="brand-logo" className="flex items-center gap-2 group">
          <div className="w-8 h-8 rounded-xl bg-gradient-to-br from-[#7DF9FF] to-[#A78BFA] flex items-center justify-center cf-glow-soft">
            <Flame className="w-4 h-4 text-[#07071A]" />
          </div>
          <span className="font-display text-xl font-bold tracking-tight">
            Coin<span className="cf-gradient-text">Forge</span>
          </span>
        </Link>
        <nav className="hidden sm:flex items-center gap-1">
          <NavLink to="/" end className={linkCls} data-testid="nav-launch">Launch</NavLink>
          <NavLink to="/explore" className={linkCls} data-testid="nav-explore">Explore</NavLink>
        </nav>
        <ConnectWalletButton />
      </div>
    </header>
  );
};

export default Header;
